import type React from 'react';

import { FilterMenuProvider } from '@vlabs/monokit/shared/ui/filter-menu';
import { Page, PageContent, PageFilters } from '@vlabs/monokit/shared/ui/page';
import { PermissionTagListTableViewer } from '@vlabs/monokit/widgets/permission-tag-list-table-viewer';

import { PermissionTagsFiltersProvider, PermissionTagListFilterMenu } from '@vlabs/monokit/entities/permission-tags/filters/';

import { PermissionTagInfo } from './PermissionTagInfo';
import { PermissionTagListPageHeader } from './PermissionTagListPageHeader';

function PermissionTagListPage(): React.JSX.Element {
  return (
    <Page>
      <PermissionTagsFiltersProvider>
        <FilterMenuProvider>
          <PageContent>
            <PermissionTagListPageHeader />
            <PermissionTagInfo />
            <PermissionTagListTableViewer />
          </PageContent>
          <PageFilters>
            <PermissionTagListFilterMenu />
          </PageFilters>
        </FilterMenuProvider>
      </PermissionTagsFiltersProvider>
    </Page>
  );
}

export { PermissionTagListPage };
